import ganttChartStyles from "../../styles/ganttChart/ganttChart.module.css";
import colors from "../../utils/colors";
import TinyDivider from "../UI/TinyDivider";
import { useAppSelector } from "../../store/hooks";
import KpiComparisonContinuity from "./KpiComparisonContinuity";
import KpiComparisonDistance from "./KpiComparisonDistance";
import KpiComparisonPreference from "./KpiComparisonPreference";
import KpiComparisonTimePreference from "./KpiComparisonTimePreference";
import labels from "../../utils/labels";

const KPIListOverview = ({ continuity }: { continuity: number }) => {
  const { kpiData } = useAppSelector((state) => state.kpiCollectionSlice);
  const { selectedGanttChartTab } = useAppSelector(
    (state) => state.ganttChartSlice,
  );
  const pondoo = kpiData?.pondooDashboard;
  const nexus = kpiData?.nexusDashboard;

  return (
    <div className="flex gap-[--spacing-sm] items-center">
      <div className="flex gap-[--spacing-sm] items-center whitespace-nowrap">
        <span
          className={ganttChartStyles.kpiBullet}
          style={{ backgroundColor: colors.getBackgroundColor(continuity) }}
        ></span>{" "}
        <p className="label">
          {selectedGanttChartTab === "Original"
            ? nexus?.plan.continuity
            : pondoo?.plan.continuity}{" "}
          {labels.continuity}
        </p>
        {pondoo && nexus && selectedGanttChartTab !== "Original" && (
          <KpiComparisonContinuity
            variant="icon"
            value={pondoo.plan.continuity}
            compareValue={nexus.plan.continuity}
          />
        )}
      </div>
      <TinyDivider colorVariant="PRIMARY" />{" "}
      <p className="label">
        {selectedGanttChartTab === "Original"
          ? nexus?.otherKpi.drivenKilometers
          : pondoo?.otherKpi.drivenKilometers}{" "}
        {labels.distanceMeassurement}
      </p>
      {pondoo && nexus && selectedGanttChartTab !== "Original" && (
        <KpiComparisonDistance
          value={pondoo.otherKpi.drivenKilometers}
          compareValue={nexus.otherKpi.drivenKilometers}
          variant="icon"
        />
      )}
      <TinyDivider colorVariant="PRIMARY" />{" "}
      <p className="label">
        <span>
          {selectedGanttChartTab === "Original"
            ? nexus?.plan.percentCompliedEmployeePreferences
            : pondoo?.plan.percentCompliedEmployeePreferences}
          %
        </span>{" "}
        {labels.kpiPreferences}
      </p>
      {pondoo && nexus && selectedGanttChartTab !== "Original" && (
        <KpiComparisonPreference
          variant="icon"
          total={pondoo.plan.totalEmployeePreferences}
          percentComplied={pondoo.plan.percentCompliedEmployeePreferences}
          compareTotal={nexus.plan.totalEmployeePreferences}
          comparePercentComplied={nexus.plan.percentCompliedEmployeePreferences}
        />
      )}
      <TinyDivider colorVariant="PRIMARY" />
      <p className="label">
        <span>
          {selectedGanttChartTab === "Original"
            ? nexus?.plan.percentCompliedTimePreferences
            : pondoo?.plan.percentCompliedTimePreferences}
          %
        </span>{" "}
        {labels.kpiPreferred}
      </p>
      {pondoo && nexus && selectedGanttChartTab !== "Original" && (
        <KpiComparisonTimePreference
          variant="icon"
          total={pondoo.plan.totalTimePreferences}
          percentComplied={pondoo.plan.percentCompliedTimePreferences}
          compareTotal={nexus.plan.totalTimePreferences}
          comparePercentComplied={nexus.plan.percentCompliedTimePreferences}
        />
      )}
    </div>
  );
};

export default KPIListOverview;
